import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import DeclinedCheckOnPetsScreen from 'ContactApp/containers/CheckOnPets/Declined'
import CheckOnPetsScreen from 'ContactApp/containers/CheckOnPets'
import PetSafetyScreen from 'ContactApp/containers/PetSafety'
import SuccessPetSafetyScreen from 'ContactApp/containers/PetSafety/Success'
// DISABLE TASKS FEATURE (reversible)
// import TasksScreen from 'ContactApp/containers/Tasks'
import InvitationScreen from 'ContactApp/containers/Invitation'

import InvitationDeclinedScreen from 'ContactApp/containers/Invitation/Declined'
import InvitationAcceptedScreen from 'ContactApp/containers/Invitation/Accepted'
import VaultAccessScreen from 'ContactApp/containers/Vault/Access'
import VaultDetailsScreen from 'ContactApp/containers/Vault/Details'
import ExpiredVaultScreen from 'ContactApp/screens/Vault/Expired'
import InvitationPetParentEmailScreen from 'ContactApp/containers/Invitation-PetParent-Email'
import InvitationAcceptedScreenContainer from 'ContactApp/containers/Invitation-PetParent-Email/Accepted'
import InvitationPetParentPhoneScreenContainer from 'ContactApp/containers/Invitation-PetParent-Phone'
import InvitationAcceptedPhoneScreenContainer from 'ContactApp/containers/Invitation-PetParent-Phone/Accepted'

function App() {
  return (
    <Switch>
      <Route path='/i/:token/declined' component={InvitationDeclinedScreen} />
      <Route path='/i/:token/accepted' component={InvitationAcceptedScreen} />
      <Route path='/i/:token' component={InvitationScreen} />
      <Route path='/pie/:token/accepted' component={InvitationAcceptedScreenContainer} />
      <Route path='/pie/:token' component={InvitationPetParentEmailScreen} />
      <Route path='/pip/:token/accepted' component={InvitationAcceptedPhoneScreenContainer} />
      <Route path='/pip/:token' component={InvitationPetParentPhoneScreenContainer} />
      <Route path='/s/:token/success' component={SuccessPetSafetyScreen} />
      <Route path='/s/:token' component={PetSafetyScreen} />
      {/* DISABLE TASKS FEATURE (reversible) */}
      {/* Original tasks token route (reversible) */}
      {/* <Route path='/t/:token' component={TasksScreen} /> */}
      <Route
        path='/t/:token'
        render={() => <Redirect to='/' />}
      />
      <Route
        path='/c/:token/vault/:id/details'
        component={VaultDetailsScreen}
      />
      <Route path='/c/:token/vault/:id' component={VaultAccessScreen} />
      <Route path='/c/:token/expired' component={ExpiredVaultScreen} />
      <Route path='/c/:token/declined' component={DeclinedCheckOnPetsScreen} />
      <Route path='/c/:token' component={CheckOnPetsScreen} />
    </Switch>
  )
}

export default App
